"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on 22.01.2019
 */

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * Converts attributes of PromoRegularVolumeOutput
 * @author ZSr
 */


var PromoRegularVolumeOutputConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(PromoRegularVolumeOutputConverter, _DataObjectConverter_);

  function PromoRegularVolumeOutputConverter() {
    _classCallCheck(this, PromoRegularVolumeOutputConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(PromoRegularVolumeOutputConverter).apply(this, arguments));
  }

  return PromoRegularVolumeOutputConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.PromoRegularVolumeOutputConverter = PromoRegularVolumeOutputConverter;